/** 免登录白名单（匹配路由 path） */
const whiteListByPath = ['/login']

/** 免登录白名单（匹配路由 name） */
const whiteListByName = [
  // 营销活动页：游客可浏览，领券等操作内部再引导登录
  'MarketingPage',
  'MarketingPagePreview',
  'MarketingPageFallback',
]

/** 判断是否在白名单 */
export function isWhiteList(to) {
  // path 和 name 任意一个匹配上即可
  return whiteListByPath.includes(to.path) || whiteListByName.includes(to.name)
}
